import React from "react";
import FreePlanCard from "../../ui/freePlanCard";

function BillingTab() {
  return (
    <div className="min-h-[calc(100vh-340px)] flex justify-center items-center overflow-hidden" >
      <FreePlanCard  />
    </div>
  );
}

export default BillingTab;
